import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { API } from "@/lib/api";
import { viewHeaders } from "@/lib/viewTenant";

// Fetch an auth-protected image and return an object URL (null if missing).
export function useAuthedBlob(path, version = 0) {
  const { getToken } = useAuth();
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let revoke = null;
    let cancelled = false;
    setUrl(null);
    if (!path) return undefined;
    (async () => {
      try {
        const res = await fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${await getToken()}`, ...viewHeaders() } });
        if (!res.ok || cancelled) return;
        const u = URL.createObjectURL(await res.blob());
        revoke = () => URL.revokeObjectURL(u);
        setUrl(u);
      } catch { /* no logo */ }
    })();
    return () => { cancelled = true; if (revoke) revoke(); };
  }, [path, version, getToken]);
  return url;
}
